import { createAction } from '@reduxjs/toolkit';

export const setSelectedFilePermissionId = createAction(
  'projectGallery/set-selected-file-permission'
);

export const clearGalleryData = createAction(
  'projectGallery/clear-gallery-data'
);

export const setDateRangeFilter = createAction(
  'projectGallery/set-date-range-filter'
);

// Optimistically sets a media file permission's total view count (payload:
// { id, viewCount }) after the image-view endpoint returns the new count, so the
// gallery badge updates without refetching.
export const setFilePermissionViewCount = createAction(
  'projectGallery/set-file-permission-view-count'
);
